var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPipelinealterrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 5,
    viewBox: "0 0 8 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.898438 0V1.81818H4.25508L4.5348 0.681818L4.25508 0H0.898438Z",
    fill: "#40FFA3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.625 0H7.26136V1.81818H3.625V0Z",
    fill: "#1DBC70"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.898438 2.27246V4.09064H4.25508L4.5348 2.95428L4.25508 2.27246H0.898438Z",
    fill: "#40FFA3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.625 2.27246H7.26136V4.09064H3.625V2.27246Z",
    fill: "#1DBC70"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipelinealterrow);
export default __webpack_public_path__ + "static/media/pipelinealterrow.22dabaa84fd2c223504f52f411105abe.svg";
export { ForwardRef as ReactComponent };